<template>
  <v-container fluid class="pa-0">
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('inGame.stockRemains')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="changeType">{{type === "area" ? 'Bar' : 'Line'}}</v-btn>
      </v-toolbar>
      <v-card-text>
        <v-layout wrap>
          <v-flex xs6 v-for="(company, index) in $store.getters['games/assignableCompanies'].length" :key="company._id">
            <div :id="'chart-stockdelay' + index"></div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "Resume",
  data() {
    return {
      type: "bar",
      charts: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let png = []
      this.$store.getters["games/assignableCompanies"].forEach((company, index) => {
        this.render(company, index);
      })
      setTimeout(async () => {
        for (let index = 0; index < this.$store.getters["games/assignableCompanies"].length; index++) {
          let res = await this.charts[index].dataURI()
          png.push(res)
        }
        this.$emit('png', {chart: 'stockdelay', png: png})
      }, 1000)
    },
    render(company, index) {
      let categories = this.categories(company)
      let series = this.series(company)
      let stacked = this.type == 'bar' ? true : false
      if (this.charts[index]) {
        this.charts[index].updateOptions({
          series: series,
          xaxis: {
            categories: categories
          },
          chart: {
            type: this.type,
            stacked: stacked
          }
        }, true);
      } else {
        this.charts[index] = new ApexCharts(document.querySelector("#chart-stockdelay" + index), {
          colors:['#008ffb', '#E91E63'],
          series: series,
          xaxis: {
            categories: categories
          },
          yaxis: {
            min: Math.floor(this.min / 10) * 10,
            max: Math.ceil(this.max / 10) * 10
          },
          chart: {
            type: this.type,
            height: 400,
            width: 800,
            stacked: stacked,
            animations: {
              enabled: false
            }
          },
          dataLabels: {
            enabled: false,
          },
          title: {
            text: company.name,
            align:  'center'
          }
        });
        this.charts[index].render();
      }
    },
    categories() {
      let categories = [];
      for (let index = 0; index < this.week; index++) {
        categories.push(this.$t("general.smallWeek") + (index + 1));
      }
      return categories;
    },
    series(company) {
      let series = [];
      series.push({
        name: company.name + ' (' + this.$t('inGame.stock') + ')',
        data: company.data.value.stock
      });
      series.push({
        name: company.name + ' (' + this.$t('inGame.shortage') + ')',
        data: company.data.value.remains.map((val) => -val)
      });
      return series;
    },
    async changeType () {
      for (let index = 0; index < this.charts.length; index++) {
        await this.charts[index].destroy()
        this.charts[index] = null
      }

      if (this.type == 'area') {
        this.type = 'bar'
      } else {
        this.type = 'area'
      }
      this.$store.getters["games/assignableCompanies"].forEach((company, index) => {
        this.render(company, index);
      })
    }
  },
  computed: {
    week() {
      let max = 0;
      this.$store.getters["games/assignableCompanies"].forEach(company => {
        if (company.data.value.remains.length > max) {
          max = company.data.value.remains.length;
        }
      });
      return max;
    },
    min() {
      let min = 0
      this.$store.getters["games/assignableCompanies"].forEach(company => {
        company.data.value.remains.forEach(remain => {
          if (remain > min) {
            min = remain
          }
        });
      });
      return -min
    },
    max() {
      let max = 0
      this.$store.getters["games/assignableCompanies"].forEach(company => {
        company.data.value.stock.forEach(stock => {
          if (stock > max) {
            max = stock
          }
        });
      });
      return max;
    }
  }
};
</script>
